import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import googleIcon from "../../images/google-icon.svg";
import { login, checkEmailBeforeRegister } from "../../actions/auth";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { EyeIcon, EyeOffIcon, EmailIcon, LockIcon } from "../icons";
import i18next from "i18next";
import { FiArrowRight } from "react-icons/fi";
import { useGoogleSignIn } from "../../hooks";
import { ModalCloseButton } from "../motion";
import "./motion-modal.css";

const CustomerRegister = ({
  login,
  isAuthenticated,
  useModal,
  setIsRegister,
  modalId,
  isBooking,
  book,
}) => {
  const { t } = useTranslation();

  const changeLanguage = (lng) => {
    i18next.changeLanguage(lng.toLowerCase());
  };

  useEffect(() => {
    const lang = localStorage.getItem("lang");
    if (lang !== null) changeLanguage(lang);
  }, []);
  const history = useHistory();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    password_confirmation: "",
    sign_up_with_google: false,
    access_token_google: null,
    avatar: null,
  });
  const [isGoogleSignUp, setIsGoogleSignUp] = useState(false);
  const [checkEmailMessage, setCheckEmailMessage] = useState("");
  const [showErrorCheckEmail, setShowErrorCheckEmail] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPasswordConfirm1, setShowPasswordConfirm1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [showPasswordConfirm2, setShowPasswordConfirm2] = useState(false);

  const handleGoogleCredential = async ({ credential, email: userEmail, picture: userImageURL }) => {
    try {
      // `credential` is the Google ID token (JWT) returned by GIS. The backend
      // verifies it and derives the email; the decoded email/picture are only
      // used for the registration prefill.
      const checkLoginWithGoogle = await login(
        userEmail,
        credential,
        "google"
      );

      if (!checkLoginWithGoogle) {
        setFormData({
          ...formData,
          sign_up_with_google: true,
          email: userEmail,
          access_token_google: credential,
          avatar: userImageURL,
        });

        const checkEmailStatus = await checkEmailBeforeRegister({
          ...formData,
          sign_up_with_google: true,
          email: userEmail,
          access_token_google: credential,
          avatar: userImageURL,
          role: "individual",
        });

        if (checkEmailStatus.data.code == 200) {
          setIsGoogleSignUp(true);
        } else {
          setCheckEmailMessage(checkEmailStatus.data.desc);
          setShowErrorCheckEmail(true);
        }
      }
    } catch (error) {
      console.error("Error signing in:", error);
      console.log("Error details:", JSON.stringify(error, null, 2));
    }
  };

  const { signIn: handleSignUpGoogle, hiddenButtonRef } =
    useGoogleSignIn(handleGoogleCredential);

  useEffect(() => {
    if (isGoogleSignUp) {
      const button = document.getElementById("closeModal");

      button.click();

      history.push({
        pathname: "/register",
        state: { formData },
      });
    }
  }, [isGoogleSignUp, history, formData]);

  const onSubmit = async (e) => {
    const checkEmailStatus = await checkEmailBeforeRegister({
      ...formData,
      role: "individual",
    });

    if (checkEmailStatus.data.code == 200) {
      e.preventDefault();
      const button = document.getElementById("closeModal");
      button.click();
      history.push({
        pathname: "/register",
        state: { formData },
      });
    } else {
      setFormData({
        ...formData,
        password: "",
        password_confirmation: "",
      });
      setCheckEmailMessage(checkEmailStatus.data.desc);
      setShowErrorCheckEmail(true);
    }
  };

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const togglePasswordVisibility1 = () => {
    setShowPassword1(!showPassword1);
  };

  const togglePasswordConfirmVisibility1 = () => {
    setShowPasswordConfirm1(!showPasswordConfirm1);
  };

  const togglePasswordVisibility2 = () => {
    setShowPassword2(!showPassword2);
  };

  const togglePasswordConfirmVisibility2 = () => {
    setShowPasswordConfirm2(!showPasswordConfirm2);
  };

  if (isAuthenticated) {
    if (isBooking) {
      book();
    } else {
      history.push("/");
      // window.location.reload();
    }
  }
  return (
    <Fragment>
      {/* Off-screen Google Identity Services button, clicked programmatically
          by the visible "Continue with Google" button. */}
      <div
        ref={hiddenButtonRef}
        aria-hidden="true"
        style={{ position: "absolute", left: "-9999px", top: "-9999px" }}
      ></div>
      {useModal == true || isBooking == true ? (
        <div
          className="modal fade tlf-motion-modal"
          id={modalId}
          tabIndex="1"
          aria-labelledby="loginLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered ">
            <div className="modal-content tw:overflow-hidden">
              <div className="modal-body tw:!p-7">
                <div className="tw:flex tw:justify-between tw:items-center tw:pb-6 tw:border-b tw:border-b-[#EEEEEE] tw:mb-6">
                  <div className="tw:font-hanken-grotesk tw:font-semibold tw:text-lg">
                    {t("sign_up.sign_up")}
                  </div>

                  <div className="">
                    <ModalCloseButton isInline data-bs-dismiss="modal" id="closeModal" />
                  </div>
                </div>
                {/* START FORM */}
                {showErrorCheckEmail && (
                  <>
                    <div className="alert alert-danger">
                      {t(checkEmailMessage)}
                    </div>
                  </>
                )}
                <div className="tw:space-y-3">
                  <div className="tw:relative tw:border tw:border-[#C9C9C9] tw:rounded-md tw:h-[54px] tw:flex tw:items-center tw:px-[15px]">
                    <div className="tw:py-[10px] tw:w-[27px]">
                      <EmailIcon />
                    </div>
                    <div className="tw:relative tw:w-full tw:h-full tw:flex tw:items-center tw:py-[10px]">
                      <input
                        type="text"
                        id="email"
                        name="email"
                        placeholder=" "
                        onChange={(e) => onChange(e)}
                        className={`tw:block tw:appearance-none tw:peer tw:w-full tw:outline-none tw:!mt-4 tw:!text-sm`}
                      />
                      <label
                        htmlFor="email"
                        className="tw:cursor-text tw:absolute tw:text-sm tw:font-hanken-grotesk tw:text-[#A7A7A7] tw:duration-300 tw:transform tw:-translate-y-4 tw:scale-75 tw:pt-2 tw:top-4 tw:z-10 tw:origin-[0]
                                                  tw:peer-placeholder-shown:scale-100 tw:peer-placeholder-shown:translate-y-0 tw:peer-placeholder-shown:pt-0
                                                  tw:peer-focus:scale-75 tw:peer-focus:-translate-y-4 tw:peer-focus:pt-2
                                                   tw:w-full
                                                  "
                      >
                        {t("login.email_address")}
                      </label>
                    </div>
                  </div>
                  <div className="tw:relative tw:border tw:border-[#C9C9C9] tw:rounded-md tw:h-[54px] tw:flex tw:items-center tw:px-[15px]">
                    <div className="tw:py-[10px] tw:w-[27px]">
                      <LockIcon />
                    </div>
                    <div className="tw:relative tw:w-full tw:h-full tw:flex tw:items-center tw:py-[10px]">
                      <input
                        type={showPassword1 ? "text" : "password"}
                        id="password"
                        name="password"
                        placeholder=" "
                        onChange={(e) => onChange(e)}
                        className={`tw:block tw:appearance-none tw:peer tw:w-full tw:outline-none tw:!mt-4 tw:!text-sm`}
                      />
                      <label
                        htmlFor="password"
                        className="tw:cursor-text tw:absolute tw:text-sm tw:font-hanken-grotesk tw:text-[#A7A7A7] tw:duration-300 tw:transform tw:-translate-y-4 tw:scale-75 tw:pt-2 tw:top-4 tw:z-10 tw:origin-[0] 
                                                  tw:peer-placeholder-shown:scale-100 tw:peer-placeholder-shown:translate-y-0 tw:peer-placeholder-shown:pt-0
                                                  tw:peer-focus:scale-75 tw:peer-focus:-translate-y-4 tw:peer-focus:pt-2
                                                   tw:w-full
                                                  "
                      >
                        {t("login.password")}
                      </label>
                      <div
                        onClick={togglePasswordVisibility1}
                        style={{
                          position: 'absolute',
                          right: '16px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          cursor: 'pointer',
                          zIndex: 5,
                          display: 'flex',
                          alignItems: 'center',
                          padding: '4px'
                        }}
                      >
                        {showPassword1 ? (
                          <EyeIcon />
                        ) : (
                          <EyeOffIcon />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="tw:relative tw:border tw:border-[#C9C9C9] tw:rounded-md tw:h-[54px] tw:flex tw:items-center tw:px-[15px]">
                    <div className="tw:py-[10px] tw:w-[27px]">
                      <LockIcon />
                    </div>
                    <div className="tw:relative tw:w-full tw:h-full tw:flex tw:items-center tw:py-[10px]">
                      <input
                        type={showPasswordConfirm1 ? "text" : "password"}
                        id="password_confirmation"
                        name="password_confirmation"
                        placeholder=" "
                        onChange={(e) => onChange(e)}
                        className={`tw:block tw:appearance-none tw:peer tw:w-full tw:outline-none tw:!mt-4 tw:!text-sm`}
                      />
                      <label
                        htmlFor="password_confirmation"
                        className="tw:cursor-text tw:absolute tw:text-sm tw:font-hanken-grotesk tw:text-[#A7A7A7] tw:duration-300 tw:transform tw:-translate-y-4 tw:scale-75 tw:pt-2 tw:top-4 tw:z-10 tw:origin-[0] 
                                                  tw:peer-placeholder-shown:scale-100 tw:peer-placeholder-shown:translate-y-0 tw:peer-placeholder-shown:pt-0
                                                  tw:peer-focus:scale-75 tw:peer-focus:-translate-y-4 tw:peer-focus:pt-2
                                                   tw:w-full
                                                  "
                      >
                        {t("sign_up.password_confirm")}
                      </label>
                      <div
                        onClick={togglePasswordConfirmVisibility1}
                        style={{
                          position: 'absolute',
                          right: '16px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          cursor: 'pointer',
                          zIndex: 5,
                          display: 'flex',
                          alignItems: 'center',
                          padding: '4px'
                        }}
                      >
                        {showPasswordConfirm1 ? (
                          <EyeIcon />
                        ) : (
                          <EyeOffIcon />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tw:!space-y-3 tw:mt-6 tw:text-center">
                  <button
                    name=""
                    id=""
                    type="submit"
                    className="tw:!w-full tw:!bg-[#D4B055] tw:h-[50px] tw:!rounded-md tw:!text-white tw:!flex tw:items-center tw:!justify-center tw:gap-[10px] tw:leading-5"
                    href="#"
                    role="button"
                    onClick={(e) => onSubmit(e)}
                  >
                    <div className="tw:font-hanken-grotesk tw:font-bold tw:text-sm">
                      {t("sign_up.proceed")}
                    </div>
                    <FiArrowRight size={24} />
                  </button>
                  <div>
                    <a
                      href="#"
                      className="tw:!no-underline"
                      data-bs-dismiss="modal"
                      data-bs-toggle="modal"
                      data-bs-target="#login"
                      style={{ fontSize: "14px" }}
                    >
                      <span
                        className="tw:font-hanken-grotesk tw:text-[#212529]"
                        dangerouslySetInnerHTML={{
                          __html: t("sign_up.already_have_account"),
                        }}
                      ></span>
                    </a>
                  </div>
                </div>

                <div className="tw:flex tw:items-center tw:space-x-4 tw:mt-6">
                  <div className="tw:bg-[#EEEEEE] tw:h-[1px] tw:flex-1"></div>
                  <div className="tw:font-hanken-grotesk tw:text-[#212529] tw:text-sm tw:whitespace-nowrap tw:flex-shrink-0 tw:capitalize">
                    {t("login.or_google")}
                  </div>
                  <div className="tw:bg-[#EEEEEE] tw:h-[1px] tw:flex-1"></div>
                </div>
                <div className="justify-content-center tw:mt-6">
                  <div className="">
                    <a
                      name=""
                      id=""
                      className="tw:!h-[50px] tw:flex tw:items-center tw:justify-center tw:rounded-md tw:border tw:border-[#8D8D8D] tw:!no-underline tw:space-x-[10px]"
                      role="button"
                      onClick={handleSignUpGoogle}
                    >
                      <img
                        src={googleIcon}
                        className="img-fluid"
                        alt="Efficiency"
                      />
                      <span className="tw:font-hanken-grotesk tw:text-[#282828] tw:text-sm">
                        {t("sign_up.continue_w_google")}
                      </span>
                    </a>
                  </div>
                </div>
                {/* END FORM */}
              </div>
              {process.env.REACT_APP_BUSINESS_AUTH === "true" && (
                <Link to="/business-register">
                  <div
                    className="tw:bg-[#212529] tw:flex tw:items-center tw:justify-between tw:h-[54px] tw:px-7 tw:cursor-pointer tw:mt-1"
                    data-bs-dismiss="modal"
                  >
                    <span className="tw:text-white tw:font-hanken-grotesk tw:text-sm">
                      {t("sign_up.business_sign_up")}
                    </span>
                    <FiArrowRight size={14} className="tw:text-white" />
                  </div>
                </Link>
              )}
            </div>
          </div>
        </div>
      ) : (
        <>
          {/* START FORM */}
          {showErrorCheckEmail && (
            <>
              <div className="alert alert-danger">{t(checkEmailMessage)}</div>
            </>
          )}
          <div className="tw:mx-5">
            <div className="tw:flex tw:justify-between tw:items-center tw:pb-6 tw:border-b tw:border-b-[#EEEEEE] tw:mb-6">
              <div className="tw:font-hanken-grotesk tw:font-semibold tw:text-lg">
                {t("sign_up.sign_up")}
              </div>

              <div className="">
                <button
                  type="button"
                  className="btn-close"
                  onClick={history.goBack}
                ></button>
              </div>
            </div>
            {/* START FORM */}
            {showErrorCheckEmail && (
              <>
                <div className="alert alert-danger">{t(checkEmailMessage)}</div>
              </>
            )}
            <div className="tw:space-y-3">
              <div className="tw:relative tw:border tw:border-[#C9C9C9] tw:rounded-md tw:h-[54px] tw:flex tw:items-center tw:px-[15px]">
                <div className="tw:py-[10px] tw:w-[27px]">
                  <EmailIcon />
                </div>
                <div className="tw:relative tw:w-full tw:h-full tw:flex tw:items-center tw:py-[10px]">
                  <input
                    type="text"
                    id="mobile_register_email"
                    name="email"
                    placeholder=" "
                    onChange={(e) => onChange(e)}
                    className={`tw:block tw:appearance-none tw:peer tw:w-full tw:outline-none tw:!mt-4 tw:!text-sm`}
                  />
                  <label
                    htmlFor="mobile_register_email"
                    className="tw:cursor-text tw:absolute tw:text-sm tw:font-hanken-grotesk tw:text-[#A7A7A7] tw:duration-300 tw:transform tw:-translate-y-4 tw:scale-75 tw:pt-2 tw:top-4 tw:z-10 tw:origin-[0]
                                                  tw:peer-placeholder-shown:scale-100 tw:peer-placeholder-shown:translate-y-0 tw:peer-placeholder-shown:pt-0
                                                  tw:peer-focus:scale-75 tw:peer-focus:-translate-y-4 tw:peer-focus:pt-2
                                                   tw:w-full
                                                  "
                  >
                    {t("login.email_address")}
                  </label>
                </div>
              </div>
              <div className="tw:relative tw:border tw:border-[#C9C9C9] tw:rounded-md tw:h-[54px] tw:flex tw:items-center tw:px-[15px]">
                <div className="tw:py-[10px] tw:w-[27px]">
                  <LockIcon />
                </div>
                <div className="tw:relative tw:w-full tw:h-full tw:flex tw:items-center tw:py-[10px]">
                  <input
                    type="password"
                    id="mobile_register_password"
                    name="password"
                    placeholder=" "
                    onChange={(e) => onChange(e)}
                    className={`tw:block tw:appearance-none tw:peer tw:w-full tw:outline-none tw:!mt-4 tw:!text-sm`}
                  />
                  <label
                    htmlFor="mobile_register_password"
                    className="tw:cursor-text tw:absolute tw:text-sm tw:font-hanken-grotesk tw:text-[#A7A7A7] tw:duration-300 tw:transform tw:-translate-y-4 tw:scale-75 tw:pt-2 tw:top-4 tw:z-10 tw:origin-[0] 
                                                  tw:peer-placeholder-shown:scale-100 tw:peer-placeholder-shown:translate-y-0 tw:peer-placeholder-shown:pt-0
                                                  tw:peer-focus:scale-75 tw:peer-focus:-translate-y-4 tw:peer-focus:pt-2
                                                   tw:w-full
                                                  "
                  >
                    {t("login.password")}
                  </label>
                </div>
              </div>
              <div className="tw:relative tw:border tw:border-[#C9C9C9] tw:rounded-md tw:h-[54px] tw:flex tw:items-center tw:px-[15px]">
                <div className="tw:py-[10px] tw:w-[27px]">
                  <LockIcon />
                </div>
                <div className="tw:relative tw:w-full tw:h-full tw:flex tw:items-center tw:py-[10px]">
                  <input
                    type={showPasswordConfirm2 ? "text" : "password"}
                    id="mobile_register_password_confirmation"
                    name="password_confirmation"
                    placeholder=" "
                    onChange={(e) => onChange(e)}
                    className={`tw:block tw:appearance-none tw:peer tw:w-full tw:outline-none tw:!mt-4 tw:!text-sm`}
                  />
                  <label
                    htmlFor="mobile_register_password_confirmation"
                    className="tw:cursor-text tw:absolute tw:text-sm tw:font-hanken-grotesk tw:text-[#A7A7A7] tw:duration-300 tw:transform tw:-translate-y-4 tw:scale-75 tw:pt-2 tw:top-4 tw:z-10 tw:origin-[0] 
                                                  tw:peer-placeholder-shown:scale-100 tw:peer-placeholder-shown:translate-y-0 tw:peer-placeholder-shown:pt-0
                                                  tw:peer-focus:scale-75 tw:peer-focus:-translate-y-4 tw:peer-focus:pt-2
                                                   tw:w-full
                                                  "
                  >
                    {t("sign_up.password_confirm")}
                  </label>
                  <div
                    onClick={togglePasswordConfirmVisibility2}
                    style={{
                      position: 'absolute',
                      right: '16px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      cursor: 'pointer',
                      zIndex: 5,
                      display: 'flex',
                      alignItems: 'center',
                      padding: '4px'
                    }}
                  >
                    {showPasswordConfirm2 ? (
                      <EyeIcon />
                    ) : (
                      <EyeOffIcon />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="tw:!space-y-3 tw:mt-6 tw:text-center">
              <button
                name=""
                id=""
                type="submit"
                className="tw:!w-full tw:!bg-[#D4B055] tw:h-[50px] tw:!rounded-md tw:!text-white tw:!flex tw:items-center tw:!justify-center tw:gap-[10px] tw:leading-5"
                href="#"
                role="button"
                onClick={(e) => onSubmit(e)}
              >
                <div className="tw:font-hanken-grotesk tw:font-bold tw:text-sm">
                  {t("sign_up.proceed")}
                </div>
                <FiArrowRight size={24} />
              </button>
              <div>
                <a
                  href="#"
                  className="tw:!no-underline"
                  data-bs-dismiss="modal"
                  data-bs-toggle="modal"
                  data-bs-target="#login"
                  style={{ fontSize: "14px" }}
                >
                  <span
                    className="tw:font-hanken-grotesk tw:text-[#212529]"
                    dangerouslySetInnerHTML={{
                      __html: t("sign_up.already_have_account"),
                    }}
                  ></span>
                </a>
              </div>
            </div>

            <div className="tw:flex tw:items-center tw:space-x-4 tw:mt-6">
              <div className="tw:bg-[#EEEEEE] tw:h-[1px] tw:flex-1"></div>
              <div className="tw:font-hanken-grotesk tw:text-[#212529] tw:text-sm tw:whitespace-nowrap tw:flex-shrink-0 tw:capitalize">
                {t("login.or_google")}
              </div>
              <div className="tw:bg-[#EEEEEE] tw:h-[1px] tw:flex-1"></div>
            </div>
            <div className="justify-content-center tw:mt-6">
              <div className="">
                <a
                  name=""
                  id=""
                  className="tw:!h-[50px] tw:flex tw:items-center tw:justify-center tw:rounded-md tw:border tw:border-[#8D8D8D] tw:!no-underline tw:space-x-[10px]"
                  role="button"
                  onClick={handleSignUpGoogle}
                >
                  <img
                    src={googleIcon}
                    className="img-fluid"
                    alt="Efficiency"
                  />
                  <span className="tw:font-hanken-grotesk tw:text-[#282828] tw:text-sm">
                    {t("sign_up.continue_w_google")}
                  </span>
                </a>
              </div>
            </div>
            {/* END FORM */}
          </div>
          {process.env.REACT_APP_BUSINESS_AUTH === "true" && (
            <Link to="/business-register">
              <div
                className="tw:bg-[#212529] tw:flex tw:items-center tw:justify-between tw:h-[80px] tw:px-7 tw:cursor-pointer tw:mt-1 tw:bottom-0 tw:w-full tw:min-h-[80px] tw:mt-8"
                data-bs-dismiss="modal"
              >
                <span className="tw:text-white tw:font-hanken-grotesk tw:text-sm">
                  {t("sign_up.business_sign_up")}
                </span>
                <FiArrowRight size={14} className="tw:text-white" />
              </div>
            </Link>
          )}
        </>
      )}
    </Fragment>
  );
};

CustomerRegister.propTypes = {
  login: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, { login })(CustomerRegister);
